<template>
    <PageLoading v-if="isLoading" />
    <div v-else class="main-wrap">
        <h1>{{ $t('certificates.validate_title') }}</h1>
        <q-btn
            class="q-my-lg btn-custom"
            size="32px"
            color="secondary"
            flat
            @click="cameraShow = true"
        >
            <q-icon name="qr_code" class="q-mr-md"></q-icon>
            {{ $t('profile.verify_another_certificate') }}
        </q-btn>
        <div class="q-px-md" style="max-width: 480px">
            <qrcode-stream v-if="cameraShow" @decode="onDecode"></qrcode-stream>
        </div>
        <div class="certificte-details q-my-lg q-px-md">
            <template v-if="certificate">
                <h3 class="q-mb-md">{{ certificate.title }}</h3>
                <h4 v-if="certificate.perpetual" class="text-positive q-mb-sm">
                    {{ $t('certificates.valid') }}
                </h4>
                <h4 v-else>
                    <span
                        v-if="isExpired"
                        class="text-h6 text-uppercase text-red"
                        >{{ $t('certificates.expired') }}</span
                    >
                    <template v-else>
                        <span class="text-h6 text-uppercase"
                            >{{ $t('certificates.expires') }}:</span
                        >
                        <span class="text-h4 text-positive">{{
                            formatDate(certificate.valid_end_date)
                        }}</span>
                    </template>
                </h4>
                <span class="text-h6 text-uppercase"
                    >{{ $t('certificates.issued_on') }}:</span
                >
                <span class="text-h4">{{
                    formatDate(certificate.issued_date)
                }}</span
                ><br />
                <h6 class="q-mt-lg">
                    {{ $t('certificates.certified_person') }}
                </h6>
                <span class="text-h6 text-uppercase"
                    >{{ $t('general.name') }}:</span
                >
                <span class="text-h4">{{
                    `${certificate.user.first_name}`
                }}</span
                ><br />
                <span class="text-h6 text-uppercase"
                    >{{ $t('general.email') }}:</span
                >
                <span class="text-h4">{{ certificate.user.email }}</span
                ><br />
                <span class="text-h6 text-uppercase"
                    >{{ $t('general.tax_number') }}:</span
                >
                <span class="text-h4">{{ certificate.user.tax_number }}</span
                ><br />
            </template>
            <template v-else>
                <h4 class="text-red q-px-md">
                    {{ $t('certificates.not_valid') }}
                </h4>
                <q-btn
                    class="q-my-lg btn-custom"
                    size="32px"
                    flat
                    @click="cameraShow = true"
                >
                    <q-icon name="qr_code" class="q-mr-md"></q-icon>
                    {{ $t('profile.re-verify_certificate') }}
                </q-btn>
                <div class="q-px-md" style="max-width: 480px">
                    <qrcode-stream
                        v-if="cameraShow"
                        @decode="onDecode"
                    ></qrcode-stream>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import PageLoading from '@/components/PageLoading'
import certificatesService from '@/services/modules/profile/certificates'
import { QrcodeStream } from 'vue-qrcode-reader'
import moment from 'moment'

const loadingKeys = {
    fetchingCertificate: 'fetching-certificate',
}

export default {
    name: 'ValidateCertificate',

    components: {
        PageLoading,
        QrcodeStream,
    },

    data() {
        return {
            cameraShow: false,
            certificate: null,
        }
    },

    computed: {
        isLoading() {
            return this.isfetchingCertificate
        },

        isfetchingCertificate() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingCertificate
            ).length
        },

        isExpired() {
            var a = moment(this.certificate.valid_end_date)
            var b = moment(new Date())
            let isExpired = a.diff(b)
            if (isExpired <= 0) {
                return true
            }
            return false
        },
    },

    async created() {
        if (this.$route.params.token) {
            await this.fetchCertificate()
        }
    },

    methods: {
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY')
        },

        onDecode(decodedString) {
            this.loadingAdd(loadingKeys.fetchingCertificate)

            this.cameraShow = false
            window.location.replace('http://' + decodedString)

            this.loadingRemove(loadingKeys.fetchingCertificate)
        },

        async fetchCertificate() {
            this.loadingAdd(loadingKeys.fetchingCertificate)

            let parameters = {
                filter: {
                    hash: this.$route.params.token,
                },
            }

            let response = await certificatesService.validate(parameters)

            if (response.status === 200) {
                this.certificate = response.data.results[0]
            }

            this.loadingRemove(loadingKeys.fetchingCertificate)
        },
    },
}
</script>
